import React from "react";

export default function DataTable({
  data,
  columns,
  currentPage,
  itemsPerPage,
}) {
  return (
    <div className="overflow-x-auto -mx-3 sm:mx-0">
      <div className="inline-block min-w-full align-middle">
        <table className="min-w-full text-xs sm:text-sm text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              {columns.map((col, idx) => (
                <th key={idx} className="px-2 sm:px-4 py-2 whitespace-nowrap">
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, idx) => (
                <tr key={idx} className="border-t hover:bg-gray-50">
                  {columns.map((col, colIdx) => (
                    <td
                      key={colIdx}
                      className="px-2 sm:px-4 py-2 whitespace-nowrap"
                    >
                      {col.render
                        ? col.render(
                            item,
                            (currentPage - 1) * itemsPerPage + idx,
                          )
                        : item[col.field]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="px-4 py-4 text-center text-gray-500"
                >
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
